import React from "react";
import { Fade } from "react-awesome-reveal";
import "../styles/Agentes.scss";
import agente1 from "../images/agentes/agt1.jpg";
import agente2 from "../images/agentes/agt2.jpg";
import agente3 from "../images/agentes/agt3.jpg";
import agente4 from "../images/agentes/agt4.jpg";

const Agentes = () => {
  const agentes = [
    {
      id: 1,
      nombre: "Norma",
      correo: "normac@asesorarteenseguros.com",
      imagen: agente1,
      telefono: "5215521295332",
    },
    {
      id: 2,
      nombre: "Cristhian",
      correo: "cristhianc@asesorarteenseguros.com",
      imagen: agente2,
      telefono: "5215540467517",
    },
    {
      id: 3,
      nombre: "Karla",
      correo: "karlac@asesorarteenseguros.com",
      imagen: agente3,
      telefono: "5215526792886",
    },
    {
      id: 4,
      nombre: "Berenice",
      correo: "mberenicem@asesorarteenseguros.com",
      imagen: agente4,
      telefono: "5215540395202",
    },
  ];

  return (
    <section className="agentesContainer" id="agentes">
      <Fade>
        <h4 className="fw-bold fs-3 titleAgentes">Asesores Financieros</h4>
        <p className="subtitleAgentes">
          Conoce a algunos de los asesores que forman parte de nuestra comunidad.
        </p>
      </Fade>

      <div className="cardsContainer">
        {agentes.map((agente) => (
          <Fade key={agente.id} duration={1000}>
            <div className="cardAgente">
              <div className="imgAgenteContainer">
                <img src={agente.imagen} alt={agente.nombre} />
              </div>
              <h5 className="nombreAgente">{agente.nombre}</h5>

              <a
                href={`mailto:${agente.correo}`}
                className="correoLink"
              >
                📧 Envíame un correo electrónico
              </a>

              <a
                href={`tel:${agente.telefono}`}
                className="btnContactar"
              >
                📞 Contáctame
              </a>
            </div>
          </Fade>
        ))}
      </div>
    </section>
  );
};

export default Agentes;
